import React from 'react';
import Button from '@alltrails/shared/denali/components/Button';
import EmptyStateBase from '@alltrails/shared/components/EmptyStateBase';
import * as styles from './styles/styles.module.scss';

type TrailConditionsErrorProps = {
  onRetry: () => void;
};

/* NOTE: no translations needed for now, EN/US only feature */
const TrailConditionsError = ({ onRetry }: TrailConditionsErrorProps): JSX.Element => (
  <EmptyStateBase
    icon={null}
    title="Let's try that again"
    subText="We’re having trouble loading conditions for this trail."
    cta={<Button text="Retry" onClick={onRetry} className={styles.retry} testId="trail-conditions-error-retry" variant="primary" />}
    className={styles.errorBoundary}
    titleClassName={styles.errorTitle}
  />
);

export default TrailConditionsError;
